<template>
  <div>
    <van-nav-bar
      :title="$t('app.real_name.title')"
      :left-text="$t('app.common.back')"
      left-arrow
      @click-left="$router.push('/member/information')"
    />
    <van-form @submit="onSubmit">
      <van-field
        v-model="realName"
        name="nickName"
        :label="$t('app.real_name.real_name')"
        :placeholder="$t('app.real_name.real_name')"
        :rules="[{ required: true, message: this.$t('app.real_name.real_name_msg') }]"
      />
      <van-field
        v-model="realCard"
        name="realCard"
        :label="$t('app.real_name.id_card')"
        :placeholder="$t('app.real_name.id_card')"
        :rules="[{ required: true, message: this.$t('app.real_name.id_card_msg') }]"
      />
      <div style="margin: 16px;">
        <van-button round block type="danger" size="small" native-type="submit">
          {{$t('app.common.sure')}}
        </van-button>
      </div>
    </van-form>

      <van-popup v-model="isFirstTimeRecharge"  style="width: 90%;height:auto">
        <div class="popupContent">
          <p style="text-align:center; font-size: 17px; display:none;">{{$t("app.real_name.first_recharge_gift")}}</p>
          <div v-html="before_recharge" @click="goToRechargePopContent">
          </div>
          <van-button type="danger" size="large" @click="cancelRecharge" style="width: 40%;margin-left: 7%;height: 30%;padding:3px;border-radius:6px; margin-bottom: 42px;">{{$t("app.real_name.first_recharge_gift_cancel")}}
          </van-button>
          <van-button type="danger" size="large" @click="goToRecharge" style="width: 40%;margin-left: 5%; height: 30%;padding:3px;border-radius:6px;margin-bottom: 42px;">{{$t("app.real_name.first_recharge_gift_recharge")}}
          </van-button>
        </div>
      </van-popup>

  </div>
</template>

<script>
    export default {
      name: "RealName",
      data(){
        return{
          realName:'',
          realCard:'',
          isFirstTimeRecharge: false,
           before_recharge: "",
            sys_give_voucher_amount:"",
              isRealNameVerified: false,
           isRealNamePopShow: false,
          isRechargePopShow: false,

           isLoading:false,

          isRealNameVerified: false,

          isFirstTimeTrading: false,


          before_trading: "",


        }
      },
      methods:{
        isLogin(){
          let that = this;
          if (!that.$store.state.loginType){
            that.$router.push('/login')
          }
        },
        show(){
           this.isFirstTimeRecharge = true;
        },
         goToRechargePopContent() {
          this.$router.push({
            path:"/activity/popup_content?activityid=recharge_popup_image_mob"
          })
        },
         realNameConfig() {
          let that = this;
          that
            .$http({
                url: "/",
                method: "post",
                data: {
                  nozzle: "sysconfig",
                  token: sessionStorage.getItem("token"),
                  name:"sys_give_voucher_amount"
                }
              })
              .then(function(res) {
                if (res.data.code == 1) {
                    that.sys_give_voucher_amount = res.data.data;
                } else {
                }
              });
        },
        getUser(){
          let that = this;
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "user",
                token: sessionStorage.getItem("token")
              }
            })
            .then(function(res) {
              let resData = res.data;
              that.isLoading = false;
              if (res.data.code === 1) {
                that.cash = resData.data.cash;
                that.phone = resData.data.phone;
                that.$store.commit("changeUser", resData.data);
                if (resData.data.real == ''){
                  if(that.isRealNamePopShow) {
                    that.realNameConfig();
                    that.isRealNameVerified = true;
                  }
                }
              if(resData.data.real){
                //
                that.isFirstRecharge();
              //   if(resData.data.cash == "0.00") {
              //     that.rechargeConfig();
              //     that.isFirstTimeRecharge = true;
              // } else {
              //     that.isFirstTimeRecharge = false;
              //     //call is trade
              //   // that.isFirstTrade();
              // }
            }
              } else if (res.data.code === 0 || res.data.code === -1) {
                that.$toast.fail(that.$t(resData.msg));
              }
            })
            .catch(() => {
              that.isLoading = false;
            });
        },


        cancelRecharge() {
          this.isFirstTimeRecharge = false;
         },
         goToRecharge() {
          this.$router.push('/member/recharge')
         },
          rechargeConfig() {
          let that = this;
          that
            .$http({
                url: "/",
                method: "post",
                data: {
                  nozzle: "sysconfig",
                  token: sessionStorage.getItem("token"),
                  name:"before_recharge"
                }
              })
              .then(function(res) {
                if (res.data.code == 1) {
                    that.before_recharge = res.data.data;
                } else {

                }
              });
        },
        isFirstRecharge() {
          //  if(resData.data.cash == "0.00") {
          //         that.rechargeConfig();
          //         that.isFirstTimeRecharge = true;
          //     } else {
          //         that.isFirstTimeRecharge = false;
          //         //call is trade
          //       // that.isFirstTrade();
          //     }
          let that = this;
          that
            .$http({
                url: "/",
                method: "post",
                data: {
                  nozzle: "isfirst_recharge",
                  token: sessionStorage.getItem("token"),
                }
              })
              .then(function(res) {
                if (res.data.data == 1) {
                  that.isFirstTimeRecharge = false;
                  // that.isFirstTrade();
                  // localStorage.setItem("isFirstTimeRecharge", false);

                } else {
                  if(that.isRechargePopShow) {
                    that.rechargeConfig();
                    that.isFirstTimeRecharge = true;
                  }
                  // localStorage.setItem("isFirstTimeRecharge", true);
                }
              });
        }, isFirstTrade() {
          let that = this;
          that
            .$http({
                url: "/",
                method: "post",
                data: {
                  nozzle: "isfirst_deal",
                  token: sessionStorage.getItem("token"),
                }
              })
              .then(function(res) {
                // console.log("res",res.data.data)
                if (res.data.data == 1) {
                  that.isFirstTimeTrading = false;
                  localStorage.setItem("isFirstTimeRecharge", false);
                } else {
                  that.tradeConfig();
                  that.isFirstTimeTrading = true;
                  localStorage.setItem("isFirstTimeRecharge", true);
                }
              });
        },
        tradeConfig() {
          let that = this;
          that
            .$http({
                url: "/",
                method: "post",
                data: {
                  nozzle: "sysconfig",
                  token: sessionStorage.getItem("token"),
                  name:"before_trading"
                }
              })
              .then(function(res) {
                if (res.data.code == 1) {
                    that.before_trading = res.data.data;

                } else {
                  // that.isFirstTimeTrading = true;
                  // localStorage.setItem("isFirstTimeRecharge", true);

                }
              });
        },
        isRechargePopShowM() {
          let that = this;
          that
            .$http({
                url: "/",
                method: "post",
                data: {
                  nozzle: "sysconfig",
                  token: sessionStorage.getItem("token"),
                  name:"is_before_recharge"
                }
              })
              .then(function(res) {
                if (res.data.data == 1) {
                    that.isRechargePopShow = true;
                } else {
                  // that.isFirstTimeTrading = true;
                  // localStorage.setItem("isFirstTimeRecharge", true);
                }
              });
        },

        onSubmit(){
          let that = this;
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "certification",
                token: sessionStorage.getItem("token"),
                name: that.realName,
                card: that.realCard
              }
            })
            .then(function(res) {
              let resData = res.data;
              if (res.data.code == 1) {
                that.isFirstTimeRecharge = true;
                that.$toast.success({
                  message: that.$t(resData.msg),

                  onClose:function () {
                   // that.$router.push('/information')
                  }
                });
              } else if (res.data.code == 0 || res.data.code == -1) {
                that.$toast.fail(that.$t(resData.msg));
              }
            });
        },
      },






          isRealNamePopShowM() {
          let that = this;
          that
            .$http({
                url: "/",
                method: "post",
                data: {
                  nozzle: "sysconfig",
                  token: sessionStorage.getItem("token"),
                  name:"is_real_name_popup"
                }
              })
              .then(function(res) {
                if (res.data.data == 1) {
                    that.isRealNamePopShow = true;
                } else {
                  // that.isFirstTimeTrading = true;
                  // localStorage.setItem("isFirstTimeRecharge", true);
                }
              });
        },
 mounted:function () {
        let that = this;
        that.isLogin();
        that.isRechargePopShowM();
        // that.getUser();
        that.rechargeConfig();

      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/RealName.vue